/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */
package systems.frictionless.impulse.browser.style

import org.jetbrains.compose.web.css.CSSStyleRuleBuilder
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.GenericStyleSheetBuilder
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.pt
import org.jetbrains.compose.web.css.px
import systems.frictionless.impulse.browser.style.constants.TEXTAREA
import systems.frictionless.impulse.browser.style.constants.grid10
import systems.frictionless.impulse.browser.style.constants.grid4

fun AppStyleSheet.smallMobilePhone(styleSheetBuilder: GenericStyleSheetBuilder<CSSStyleRuleBuilder>) {
    styleSheetBuilder.apply {
        root style {
            AppStyleSheetVariables.elementWidthSmall(240.px)
            AppStyleSheetVariables.elementWidthMedium(300.px)
            AppStyleSheetVariables.elementWidthLarge(400.px)
            AppStyleSheetVariables.fontSizeSmall(8.pt)
        }

        className(progress) style {
            display(DisplayStyle.None)
        }

        className(question) style {
            paddingTop(grid4)
        }

        className(questionText) style {
            paddingTop(0.px)
        }

        desc(className(questionTextArea), type(TEXTAREA)) style {
            height(grid10)
        }
    }
}
